class HiddenUsersStorage {
  private storageKey: string;

  constructor() {
    this.storageKey = 'hidden_users';
  }

  getHiddenUserIds(): string[] {
    const storedHiddenUsers = localStorage.getItem(this.storageKey);
    if (!storedHiddenUsers) {
      return [];
    }
    
    try {
      const parsedIds = JSON.parse(storedHiddenUsers);
      return Array.isArray(parsedIds) ? parsedIds : [];
    } catch (error) {
      console.error('Error parsing hidden users from localStorage:', error);
      return [];
    }
  }

  isUserHidden(userId: string): boolean {
    return this.getHiddenUserIds().includes(userId);
  }

  hideUser(userId: string): void {
    if (!userId) {
      console.error('Cannot hide user without an ID');
      return;
    }

    const hiddenUserIds = this.getHiddenUserIds();
    
    // Don't add if already hidden
    if (hiddenUserIds.includes(userId)) {
      return;
    }
    
    const updatedIds = [...hiddenUserIds, userId];
    localStorage.setItem(this.storageKey, JSON.stringify(updatedIds));
  }

  unhideUser(userId: string): void {
    if (!userId) {
      console.error('Cannot unhide user without an ID');
      return;
    }

    const hiddenUserIds = this.getHiddenUserIds();
    const updatedIds = hiddenUserIds.filter(id => id !== userId);
    localStorage.setItem(this.storageKey, JSON.stringify(updatedIds));
  }

  clearStorage(): void {
    localStorage.removeItem(this.storageKey);
  }
}

export default HiddenUsersStorage; 